export  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }


  // Hex to RGBA 
  export const HexToRGBA=(hex,opacityvalue)=>{
    if(opacityvalue===0)
    {
      opacityvalue=1.0
    }
    const parsedOpacity=(1.0 - opacityvalue).toFixed(1);
    const cleanHex = hex.replace("#", "");
    // Convert the hexadecimal value to RGB format
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    // Return the RGB value as a string
    return `${r}, ${g}, ${b} ,${parsedOpacity}`;
  }